<template>
  <v-container>
    <v-row>
      <v-col cold="6">
        <v-select
          label="Language (optional)"
          :items="languages"
          v-model="miscellaneous.language"
          @input="updateMiscellaneous"
        ></v-select>
      </v-col>

      <v-col cold="6">
        <v-text-field
          label="Content Description (optional)"
          v-model="miscellaneous.contentDescription"
          @input="updateMiscellaneous"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Miscellaneous",
  data() {
    return {
      languages: ["en", "ch", "fr"],
    };
  },
  computed: {
    miscellaneous() {
      return this.$store.state.projectProperties.miscellaneous;
    },
  },
  methods: {
    updateMiscellaneous() {
      this.$store.dispatch("updateProjectProperties", {
        miscellaneous: this.miscellaneous,
      });
    },
  },
};
</script>
